import { useTranslations } from "use-intl";
import { useRouter } from "@/lib/next-shims/next-navigation";
import Link from "@/lib/next-shims/router-link";

// Two-button action row: "Go back" (history.back) + "Back to Dashboard" (navigate home).
export function ErrorActions() {
  const t = useTranslations();
  const router = useRouter();

  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:justify-center">
      <button
        type="button"
        onClick={() => router.back()}
        className="inline-flex items-center justify-center rounded-lg border border-[var(--border)] bg-[var(--background)] px-5 py-2.5 text-sm font-medium text-[var(--foreground)] transition-colors hover:bg-[var(--secondary)]"
      >
        {t("errors.common.action_back")}
      </button>
      <Link
        href="/"
        className="inline-flex items-center justify-center rounded-lg bg-[var(--primary)] px-5 py-2.5 text-sm font-medium text-[var(--primary-foreground)] transition-colors hover:bg-[var(--primary-700)]"
      >
        {t("errors.common.action_home")}
      </Link>
    </div>
  );
}
